/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo } from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./styles";
import theme from "theme";

const FooterItem = memo(props => {
	const classes = useStyles();
	const { title, value, isBorder } = props;

	return (
		<Grid
			classes={{ root: classes.root }}
			style={{
				borderBottom: isBorder
					? `1px solid ${theme.palette.grey[200]}`
					: "",
				marginBottom: isBorder ? 10 : 0
			}}
		>
			<Grid classes={{ root: classes.title }}>{title}</Grid>
			<Grid
				classes={{ root: classes.textQuatity }}
				style={{ color: !isBorder ? "#F84F06" : "#403F3F" }}
			>
				{value}
			</Grid>
		</Grid>
	);
});

export default FooterItem;
